import { useForumItineraryConferenceFacilitiesQuery } from "api/queries/forumItinerary";
import { useGetForumByIdQuery } from "api/queries/forums";
import MobileLinkList, { LinkListProp } from "components/MobileLinkList";
import { Grid, SpinLoading } from "components/styleguide/mobile";
import { MeetingFacilityModel } from "generated/api";
import { toNumber } from "lodash-es";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useOutletContext, useParams } from "react-router-dom";

import { PlaybookOutletContext } from "../types";

export default function PlaybookConferences() {
  const { t } = useTranslation();
  const { setTitle, setTitle2 } = useOutletContext<PlaybookOutletContext>();
  const forumId = toNumber(useParams().id);

  setTitle(t("Conferences"));

  const { data: { data: forum = {} } = {}, isLoading: isLoadingForum } = useGetForumByIdQuery({ forumId });
  const {
    data: { data: facilities = [] } = {},
    isLoading,
    isFetching,
  } = useForumItineraryConferenceFacilitiesQuery({ forumId }, { cacheTime: Infinity, staleTime: Infinity });

  useEffect(() => {
    if (isLoadingForum || !forum?.title) {
      setTitle(t("Loading..."));
    } else {
      setTitle(forum.title);
    }
    setTitle2(null);
  }, [forum.title, isLoadingForum]);

  if (!facilities || isLoading || isFetching || isLoadingForum) {
    return (
      <div className="loader">
        <SpinLoading style={{ "--size": "48px" }} />
      </div>
    );
  }

  return (
    <Grid columns={2} gap={8}>
      <MobileLinkList
        items={facilities?.map((f: MeetingFacilityModel) => {
          return {
            id: f.id.toString(),
            title: f.name,
            link: `facilities/${f.buildingId}/${f.id}`,
            footerTextLeft: f.code,
          } as LinkListProp;
        })}
      />
    </Grid>
  );
}
